import axios from "axios";

const BASE_URL = process.env.REACT_APP_API_BASE_URL;

// Action Types
export const FETCH_DASHBOARD_STATS_REQUEST = "FETCH_DASHBOARD_STATS_REQUEST";
export const FETCH_DASHBOARD_STATS_SUCCESS = "FETCH_DASHBOARD_STATS_SUCCESS";
export const FETCH_DASHBOARD_STATS_FAILURE = "FETCH_DASHBOARD_STATS_FAILURE";

// Action Types for Attendance Chart
export const FETCH_TODAY_ATTENDANCE_REQUEST = "FETCH_TODAY_ATTENDANCE_REQUEST";
export const FETCH_TODAY_ATTENDANCE_SUCCESS = "FETCH_TODAY_ATTENDANCE_SUCCESS";
export const FETCH_TODAY_ATTENDANCE_FAILURE = "FETCH_TODAY_ATTENDANCE_FAILURE";
export const FETCH_ATTENDANCE_BY_DESIGNATION_REQUEST =
  "FETCH_ATTENDANCE_BY_DESIGNATION_REQUEST";
export const FETCH_ATTENDANCE_BY_DESIGNATION_SUCCESS =
  "FETCH_ATTENDANCE_BY_DESIGNATION_SUCCESS";
export const FETCH_ATTENDANCE_BY_DESIGNATION_FAILURE =
  "FETCH_ATTENDANCE_BY_DESIGNATION_FAILURE";

// Fetch Dashboard Stats
export const fetchDashboardStats = () => async (dispatch) => {
  dispatch({ type: FETCH_DASHBOARD_STATS_REQUEST });
  const token = localStorage.getItem("token");

  try {
    const response = await axios.get(`${BASE_URL}/v1/api/admin/getDashboardStats`, {
      headers: { authorization: token },
    });
    dispatch({
      type: FETCH_DASHBOARD_STATS_SUCCESS,
      payload: response.data.data,
    });
  } catch (error) {
    const message = error.response?.data?.message || error.message;
    dispatch({
      type: FETCH_DASHBOARD_STATS_FAILURE,
      payload: message,
    });
  }
};


// Fetch Today's Attendance Status
export const fetchTodayAttendanceStatus = () => async (dispatch) => {
  dispatch({ type: FETCH_TODAY_ATTENDANCE_REQUEST });
  const token = localStorage.getItem("token");

  try {
    const response = await axios.get(`${BASE_URL}/v1/api/admin/getTodayAttendanceStatus`, {
      headers: { authorization: token },
    });

    dispatch({
      type: FETCH_TODAY_ATTENDANCE_SUCCESS,
      payload: response.data.data,
    });
  } catch (error) {
    const message = error.response?.data?.message || error.message;
    dispatch({
      type: FETCH_TODAY_ATTENDANCE_FAILURE,
      payload: message,
    });
  }
};


// ✅ New: Attendance by Designation
export const fetchAttendanceByDesignation = () => async (dispatch) => {
  dispatch({ type: FETCH_ATTENDANCE_BY_DESIGNATION_REQUEST });
  const token = localStorage.getItem("token");

  try {
    const response = await axios.get(
      `${BASE_URL}/v1/api/admin/getAttendanceByDesignation`,
      { headers: { authorization: token } }
    );

    dispatch({
      type: FETCH_ATTENDANCE_BY_DESIGNATION_SUCCESS,
      payload: response.data.data,
    });
  } catch (error) {
    const message = error.response?.data?.message || error.message;
    dispatch({
      type: FETCH_ATTENDANCE_BY_DESIGNATION_FAILURE,
      payload: message,
    });
  }
};
